import urlConfig from 'Url';

export const GET_CHANGE_DETAIL = 'GET_CHANGE_DETAIL';
export const GET_FEFUNDORDER_DETAIL = 'GET_FEFUNDORDER_DETAIL';
export const SAVE_SUBINFO = 'SAVE_SUBINFO';
export const SAVE_REFUNDINFO = 'SAVE_REFUNDINFO';
export const GET_ELE_INVOICE = 'GET_ELE_INVOICE';
export const GET_RESERVE_NEW_SEAT = 'GET_RESERVE_NEW_SEAT';
export const SAVE_RESERVE_NEW_SEAT = 'SAVE_RESERVE_NEW_SEAT';
export const QUERY_REFUNDEXTENNDDETAIL = 'QUERY_REFUNDEXTENNDDETAIL';
export const GET_SCHEME = 'GET_SCHEME';
export const GET_FILELIST = 'GET_FILELIST';
export const GET_REFUND_FEE = 'GET_REFUND_FEE';
export const RESET_SUBMIT_REASON = 'RESET_SUBMIT_REASON';
export const DOWN_LOAD_FILE = 'DOWNLOAD_FILE';


export function getChangeDetail(data, load) {
  return {
    type: GET_CHANGE_DETAIL,
    closeLoading: load,
    payload: {
      request: {
        url: urlConfig.afterSaleChangeReqDetail,
        method: 'post',
        data,
      },
    },
  };
}
//电子发票详情
export function getEleInvoice(data) {
  return {
    type: GET_ELE_INVOICE,
    payload: {
      request: {
        url: urlConfig.getPrintableTickets,
        method: 'post',
        data,
      },
    },
  };
}

export function saveSubInfo(data) {
  return { type: SAVE_SUBINFO, data };
}

export function getRefundOrderDetail(data) {
  return {
    type: GET_FEFUNDORDER_DETAIL,
    closeLoading: true,
    payload: {
      request: {
        url: urlConfig.afterGetRefundOrderDetail,
        method: 'post',
        data,
      },
    },
  };
}

export function saveRefundInfo(data) {
  return { type: SAVE_REFUNDINFO, data };
}

export function getReserveNewSeat(data) {
  return {
    type: GET_RESERVE_NEW_SEAT,
    closeLoading: true,
    payload: {
      request: {
        url: urlConfig.reserveNewSeat,
        method: 'post',
        data,
      },
    },
  };
}

export function saveReserveNewSeat(data) {
  return { type: SAVE_RESERVE_NEW_SEAT, data };
}

export function queryRefundExtendDetail(data) {
  return {
    type: QUERY_REFUNDEXTENNDDETAIL,
    closeLoading: true,
    payload: {
      request: {
        url: urlConfig.queryRefundExtendDetail,
        method: 'post',
        data,
      },
    },
  };
}

export function getScheme(data) {
  return {
    type: GET_SCHEME,
    closeLoading: true,
    payload: {
      request: {
        url: urlConfig.getScheme,
        method: 'post',
        data,
      },
    },
  };
}

export function searchRefundAttachment(data) {
  return {
    type: GET_FILELIST,
    closeLoading: true,
    payload: {
      request: {
        url: urlConfig.searchRefundAttachment + '?refundNo=' + data.refundNo,
        method: 'post',
        data,
      },
    },
  };
}
export function uploadFile(data) {
  return {
    type: GET_FILELIST,
    payload: {
      request: {
        // url: urlConfig.uploadRCattachment,
        url: urlConfig.updateFileList,
        method: 'post',
        data,
        processData: false,
        contentType: false,
      },
    },
  };
}


export function getRefundFee(data) {
  return {
    type: GET_REFUND_FEE,
    payload: {
      request: {
        url: urlConfig.afterSaleRefundFee,
        method: 'post',
        data,
      },
    },
  };
}
export function resetSubmitReason(data) {
  return {
    type: RESET_SUBMIT_REASON,
    payload: {
      request: {
        url: urlConfig.resetSubmitReason,
        method: 'post',
        data,
      },
    },
  };
}

export function downloadFile(data) {
  return {
    type: DOWN_LOAD_FILE,
    payload: {
      request: {
        url: urlConfig.downloadFile,
        method: 'post',
        data,
      },
    },
  };
}



// WEBPACK FOOTER //
// ./src/routes/routes/reformProcess/modules/actions.js